<svg #element></svg>
<ng-content></ng-content>